module.exports = __webpack_public_path__ + "static/media/bi.aaa0be4d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bi.svg
// module id = 2048
// module chunks = 0